import SheetComponent from "./index";

import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"
import {currencyFormat} from "../../components/permissions/functions";
import {DynamicIcon} from "lucide-react/dynamic";
import moment from "moment";
import {MobCard} from "../components/MobCard";
import ApiService from "../../services/ApiService";
import {
    formatedAbonnementError,
    translateAbonnementStatus,
    translateMethod,
    translateMethodIcon,
    translatePlatform,
    translateSource, translateSourceIcon
} from "../../views/app-views/paiements/functions";
import ReactCountryFlag from "react-country-flag";
import React, {Fragment} from "react";
import {
    API_BASE_URL,
    ASSET_BASE_URL,
    isMobileApp,
    MOBCOLORS,
    MOBILE_PREFIX_PATH,
    PUBLIC_BASE_URL,
} from '../../configs/AppConfig';
import {Descriptions, Image, notification, Popconfirm} from "antd";
import IntlMessage from "../../components/util-components/IntlMessage";
import {removeFieldType} from "../../views/editors/WebEditor/formPlugins";
import ModalLink from "../../modals/ModalLink";
import ModalUser from "../../modals/ModalUser";
import ModalContact from "../../modals/ModalContact";
import ModalCerfa from "../../modals/ModalCerfa";
import ModalEditCerfa from "../../modals/ModalEditCerfa";
import ModalCerfaGroupe from "../../modals/ModalCerfaGroupe";
import ModalChangeContact from "../../views/app-views/paiements/ModalChangeContact";
import ModalChangeOrigin from "../../views/app-views/paiements/ModalChangeOrigin";
import ModalDeletePaiement from "../../views/app-views/paiements/ModalDeletePaiement";
import ModalMessages from "../../views/app-views/messages/ModalEdit";
import {useActionSheet, withActionSheet} from "../providers/ActionSheetProvider";
import AppService from "../../services/AppService";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import MobPressable from "../components/MobPressable";
import {useNavigate} from "react-router-shim";

class SheetAbonnementDetail extends SheetComponent
{
    constructor(props) {
        super(props);
    }

    onClose(){

    }

    getData(){
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()
        const item= payload?.params?.item
        const parentRefresh= payload?.params?.parentRefresh

        if(item)
        {
            ApiService.post("/abonnements",{searchId:item.id,filters:{},sorter:{}}).then(res=>{
                if(Array.isArray(res.data) && res.data.length>0){
                    let _item=res.data[0]
                    sheetContext.setPayloadParams({item:_item})
                }
            })
        }

        if(typeof parentRefresh === "function"){
            parentRefresh()
        }
    }

    componentDidMount(){
        this.getAssocs()
    }

    async getAssocs() {
        var res = await ApiService.get("/auth/assoc")
        if (res.success) {
            this.setState({assocs: res.data})
        }
    }

    calculRangeAbonnement(row){
        if(row.nb==0){
            return null
        }

        if(row.nb>0)
        {
            let payed=row.paiements.length
            let total=row.nb
            return {payed:payed,total:total}
        }

        if(row.max>0)
        {
            let payed=row.paiements.length
            let total=Math.ceil(row.max / row.payload.amount)
            return {payed:payed,total:total}
        }
    }


    async onPause(id) {

        await ApiService.post("/abonnements/pause/" + id)
        //await this.getData()

        notification.success({
            message: <IntlMessage id="success.edit"/>
        })
    }

    async onResume(id) {

        await ApiService.post("/abonnements/resume/" + id)
        //await this.getData()

        notification.success({
            message: <IntlMessage id="success.edit"/>
        })
    }

    async onCancel(id) {

        await ApiService.post("/abonnements/cancel/now/" + id)
        //await this.getData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    renderContent()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()

        const item= payload?.params?.item
        if(!item){
            return null
        }
        const row=item

        var assoc = null
        if (this.state.assocs.length > 0) {
            assoc = this.state.assocs.find(i => i.value === item.assoc)
        }

        let showExtraCard=false
        const extras=[]
        if(item?.info?.extra)
        {
            showExtraCard=true
            for(let k of Object.keys(item?.info.extra))
            {
                if(k==="ddn"){
                    extras.push({key:t`Date de Naissance`,value:moment(new Date(item?.info.extra[k])).format("DD/MM/YYYY")})
                    continue
                }
                extras.push({key:removeFieldType(k),value:item?.info.extra[k]})
            }
        }
        if(item.commentaire?.length>0 || (item?.extra && Object.keys(item?.extra).length>0) ){
            showExtraCard=true
        }

        const rangeAbonnement=this.calculRangeAbonnement(item)
        const formatedStatus=translateAbonnementStatus(item.state)


        let amountSymbol="+"
        let amountColor=MOBCOLORS.green.color
        let statusColor=MOBCOLORS.green.color

        if(item.state==="PAUSE"){
            amountColor=MOBCOLORS.orange.color
            statusColor=MOBCOLORS.orange.color
        }
        if(item.state==="MANUAL" || item.state==="CARD_EXPIRED"){
            statusColor=MOBCOLORS.red.color
            amountColor=MOBCOLORS.red.color
            amountSymbol="-"
        }

        if(item.state==="FINISHED"){
            amountSymbol=""
            amountColor=MOBCOLORS.indigo.color
            statusColor=MOBCOLORS.indigo.color
        }

        let totalAmount=0
        for(let p of row?.paiements){
            totalAmount+=p.amount
        }


        let raisonRoute=null
        switch(item.type){
            case "CAISSE":
                raisonRoute=MOBILE_PREFIX_PATH+"/cagnottes/fiche?id="+item.typeId
                break
        }

        var MENU = []

        MENU.push({
            icon:"banknote",
            text: (<Trans>Lien de Paiement</Trans>),
            onClick:()=>{
                this.modalLink.setObject(row).withLink(PUBLIC_BASE_URL + "/abonnements/manual/" + row.id)
            }
        },)

        if (row.state === "ACTIVE") {
            MENU.push({
                icon:"octagon-pause",
                warning:true,
                text: (<Trans>Mettre en Pause l'abonnement</Trans>),
                onClick:()=>{
                    this.props.actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir mettre en pause cet abonnement ?</Trans>),()=>{
                        this.onPause(row.id)
                    })
                }
            },)
        }

        if (row.state === "PAUSE") {
            MENU.push({
                icon:"circle-play",
                warning:true,
                text: (<Trans>Réactiver l'abonnement</Trans>),
                onClick:()=>{
                    this.props.actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir mettre réactiver cet abonnement ?</Trans>),()=>{
                        this.onResume(row.id)
                    })
                }
            },)
        }

        if (row.state !== "FINISHED") {
            MENU.push({
                icon:"ban",
                danger:true,
                text: (<Trans>Annuler l'abonnement</Trans>),
                onClick:()=>{
                    this.props.actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir annuler cet abonnement ?</Trans>),()=>{
                        this.onCancel(row.id)
                    })
                }
            },)
        }

        let DropdownComponent=null
        if(!isMobileApp){
            DropdownComponent= this.props.actionSheetManager.toDropdown(MENU)
            //console.log("DropdownComponent", DropdownComponent)
        }

        return(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>

                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",textAlign:"center",gap:0}}>
                    <span style={{fontSize:15}}>{moment(item.datetime).format("DD/MM/YYYY à HH:mm")}</span>
                    <span style={{fontSize:18,fontWeight:"bold",color:MOBCOLORS.blue.color}}>{item.payload.name}</span>
                </div>


                <div style={{display:"flex",flexDirection:"column",gap:20}}>
                    <MobCard style={{display:"flex",flexDirection:"column",gap:10,position:"relative"}}>

                        <div style={{position:"absolute",right:0,paddingRight:10,paddingTop:5}}>
                            {isMobileApp ?(
                                <MobEditButtonIcon icon={"ellipsis-vertical"} onClick={()=>{
                                    if(MENU.length>0) {
                                        this.props.actionSheetManager.open(MENU)
                                    }
                                }}/>
                            ):(
                                <DropdownComponent>
                                    <a onclick={(e)=>e.preventDefault()}>
                                        <MobEditButtonIcon icon={"ellipsis-vertical"}/>
                                    </a>
                                </DropdownComponent>
                            )}
                        </div>


                        <span style={{
                            alignSelf: "center",
                            color: amountColor,
                            fontWeight: "bold",
                            fontSize: 26
                        }}>{amountSymbol} {currencyFormat(item.payload.amount / 100, item.payload.devise)} <span style={{color:"#333",fontSize:15}}>/ {t`Mois`}</span></span>

                        <Divider/>

                        {assoc &&(
                            <Item name={(<Trans>Association</Trans>)} value={assoc.label}/>
                        )}

                        {item.contact &&(
                            <Item name={(<Trans>Contact</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    //this.props.sheetContext.cancel()
                                    //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+item.contact.id)

                                    this.props.sheetContext.openContact(item.contact)
                                }}>
                                    <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                                    {item.contact?.nom} {item.contact?.prenom}
                                </span>
                            </Item>
                        )}

                        {item.raisons?.[0]?.label &&(
                            <Item name={(<Trans>Raison Paiement</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    if(raisonRoute) {
                                        this.props.sheetContext.cancel()
                                        this.props.navigate(raisonRoute)
                                    }
                                }}>
                                    {item.raisons?.[0]?.label}
                                </span>
                            </Item>
                        )}

                        <Item name={(<Trans>Méthode paiement</Trans>)}>
                            <div style={{display: "flex", gap: 5}}>
                                <span>{translateMethod(item.payload.method)}</span>
                                <div style={{
                                    backgroundColor: MOBCOLORS.cyan.color,
                                    padding: 5,
                                    borderRadius: 10
                                }}>
                                    <DynamicIcon name={translateMethodIcon(item.payload.method)}
                                                 color={"#FFF"} size={15} style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}/>
                                </div>
                            </div>
                        </Item>




                        {item.payload.platform && (
                            <Item name={(<Trans>Plateforme paiement</Trans>)} value={translatePlatform(item.payload.platform)}/>
                        )}

                        {item.cardData && (
                            <Item name={(<Trans>Carte</Trans>)}>
                            <span style={{display: "flex", gap: 10, alignItems: "center", height: "100%"}}>
                               {String(item.cardData?.brand).charAt(0).toUpperCase() + String(item.cardData?.brand).slice(1)?.toLowerCase()}
                                <DividerVertical/>
                                *****{item.cardData.last}
                                <DividerVertical/>
                                 <ReactCountryFlag
                                     countryCode={item.cardData.country}
                                 />
                            </span>
                            </Item>
                        )}

                    </MobCard>

                    <MobCard>
                        <Section title={(<Trans>Informations du prélèvement</Trans>)}>

                            <Item name={(<Trans>Statut</Trans>)} value={formatedStatus} color={statusColor}/>

                            {item.state === "MANUAL" && item.error &&(
                                <Item name={(<Trans>Erreur</Trans>)} value={formatedAbonnementError(item)} color={MOBCOLORS.red.color}/>
                            )}

                            {item.state === "FINISHED" && item.canceledAt &&(
                                <Item name={(<Trans>Fini le</Trans>)} value={moment(item.canceledAt).format("DD/MM/YYYY")}/>
                            )}

                            {rangeAbonnement? (
                                <>
                                    <Item name={(<Trans>Nbr. total mois</Trans>)} value={t`${rangeAbonnement.total} Mois`}/>
                                    <Item name={(<Trans>Déjà effectué</Trans>)} value={rangeAbonnement.payed?.toString()+"/"+rangeAbonnement.total?.toString()}/>
                                </>
                            ):(
                                <>
                                    <Item name={(<Trans>Nbr. total mois</Trans>)} value={t`Infinie`}/>
                                    <Item name={(<Trans>Déjà effectué</Trans>)} value={row.paiements.length?.toString()+"/∞"}/>
                                </>
                            )}

                            <Item name={(<Trans>Total prélevé</Trans>)}>
                                <span style={{
                                    alignSelf: "center",
                                    color: MOBCOLORS.green.color,
                                    fontWeight: "bold"
                                }}>+ {currencyFormat(totalAmount / 100, item.payload.devise)}</span>
                            </Item>

                            {row.paiements.length>0 &&(
                                <Item name={(<Trans>Dernier paiement le</Trans>)} value={moment(row.paiements[0].datetime).format("DD/MM/YYYY")}/>
                            )}

                            {row.active && row.state==="ACTIVE" &&(
                                <Item name={(<Trans>Prochain paiement le</Trans>)} value={moment(row.next).format("DD/MM/YYYY")}/>
                            )}
                        </Section>
                    </MobCard>

                    {item.payload?.facturation?.adresse &&(
                        <div>

                            <MobCard>
                                <Section title={(<Trans>Informations de factuation</Trans>)}>

                                    <Item name={(<Trans>Nom Complet</Trans>)}
                                          value={item?.payload?.info?.prenom + " " + item?.payload?.info?.nom}/>
                                    <Item name={(<Trans>Email</Trans>)} value={item?.payload?.info?.email}/>
                                    <Item name={(<Trans>Téléphone</Trans>)} value={item?.payload?.info?.tel}/>
                                    {item?.payload?.facturation?.perso === false && (
                                        <Fragment>
                                            <Item name={(<Trans>Entreprise</Trans>)} value={item?.payload?.facturation?.raison}/>
                                            <Item name={(<Trans>Identifiant d'entreprise</Trans>)} value={item?.payload?.facturation?.siren}/>
                                        </Fragment>
                                    )}
                                    <Item name={(<Trans>Adresse</Trans>)} value={item?.payload?.facturation?.adresse+" "+item?.payload.facturation?.postal+" "+item?.payload.facturation?.ville+" "+item?.payload.facturation?.pays}/>

                                </Section>
                            </MobCard>
                        </div>
                    )}


                    {showExtraCard &&(
                        <MobCard>
                            {extras.map(i=>{
                                return(
                                    <Item name={i.key} value={i.value}/>
                                )
                            })}

                            {item?.payload?.commentaire &&(
                                <Item name={(<Trans>Commentaire</Trans>)} value={item?.commentaire}/>
                            )}
                        </MobCard>
                    )}

                </div>


                <ModalLink getRef={(ref) => this.modalLink = ref} onFinish={() => {
                }}/>
                <ModalUser getRef={(ref) => this.modalUser = ref} onFinish={() => {
                }}/>
                <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                }}/>
                <ModalCerfa getRef={(ref) => this.modalCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalEditCerfa getRef={(ref) => this.modalEditCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalCerfaGroupe getRef={(ref) => this.modalCerfaGroupe = ref} onFinish={() => this.getData(true)}/>
                <ModalChangeContact getRef={(ref) => this.modalChangeContact = ref} onFinish={() => this.getData()}/>
                <ModalChangeOrigin getRef={(ref) => this.modalChangeOrigin = ref} onFinish={() => this.getData()}/>
                <ModalDeletePaiement getRef={(ref) => this.modalDeletePaiement = ref} onFinish={() => this.getData()}/>
                <ModalMessages getRef={(ref) => this.modalMessages = ref} onFinish={() => {
                }}/>
            </div>
        )
    }
}

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(SheetAbonnementDetail))

function Divider(){
    return(
        <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
            <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
        </div>
    )
}

function DividerVertical(){
    return(
        <div style={{height:20,opacity:0.05}}>
            <div style={{height:"100%",borderLeft:"1px solid #4A5568"}}/>
        </div>
    )
}

function Section({title,children})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

            <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                <span style={{color:"#333",fontSize:18,fontWeight:"300"}}>{title}</span>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:10}}>
                {children}
            </div>
        </div>
    )
}

function Item({name,value,color,children,bold})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}}>

                <span style={{width:"40%",fontStyle:"italic",fontWeight:"300",color:"#333",fontSize:13}}>{name}</span>

                <div style={{display:"flex",textAlign:"right",alignItems:"flex-end",maxWidth:"60vw",overflow:"hidden",textOverflow:'ellipsis',color:color || MOBCOLORS.blue.color}}>
                    {value ?(
                        <span>{value?.replaceAll("undefined","").trim() || t`[Inconnu]`}</span>
                    ):(
                        <div>{children}</div>
                    )}
                </div>
            </div>

            <Divider/>
        </div>
    )
}

function SheetButton({name,icon,onClick})
{
    return(

        <MobPressable style={{display:"flex",alignItems:"center",gap:5,backgroundColor:MOBCOLORS.blue.backgroundColor,padding:"5px 15px",borderRadius:16}} onClick={onClick}>
            <span style={{fontWeight:"400",color:MOBCOLORS.blue.color}}>{name}</span>
            <DynamicIcon name={icon} color={MOBCOLORS.blue.color} size={18} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
        </MobPressable>
    )
}
